import styled from "styled-components";
import { V3HeadlineH1 } from "../../components";
import { AuthoryColorSchemeProps, UserThemableHeading } from "../../components/ReusableStyledComponents/FontSetUtilities";

export const ContentLoaderWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 60px;
`;

// $wide widens the column for content types that render a large media element
// (currently PDF files). Prose inside it stays at the regular content width
// through ContentTextColumn.
export const PublicContentWrapper = styled.div<{ $wide?: boolean }>`
    max-width: ${({ $wide, theme }) => ($wide ? theme.v3.layout.contentColumnWide : theme.v3.layout.contentColumn)}px;
    margin: 0 auto;
    width: 100%;
`;

export const ProgressMaterialize = styled.div`
    margin: 5px 0;
    position: relative;
    height: 4px;
    display: block;
    width: 100%;
    background-color: #c9dcfc;
    border-radius: 2px;
    margin: 0.5rem 0 1rem 0;
    overflow: hidden;
`;

export const ProgressInderterminate = styled.div`
    background-color: #387ef5;

    @keyframes indeterminate {
        0% {
        left: -35%;
        right: 100%;
        }
        60% {
        left: 100%;
        right: -90%;
        }
        100% {
        left: 100%;
        right: -90%;
        }
    }

    &:before{
        content:          '';
        position:         absolute;
        background-color: inherit;
        top:              0;
        left:             0;
        bottom:           0;
        will-change:      left, right;
        animation:        indeterminate 4.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    }
    
    &:after {
        content:          '';
        position:         absolute;
        background-color: inherit;
        top:              0;
        left:             0;
        bottom:           0;
        will-change:      left, right;
        animation:        indeterminate-short 4.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
        animation-delay: 1.15s;
    }
`;

export const UserThemableArticleTitle= styled(V3HeadlineH1)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;